import { render, staticRenderFns } from "./SelectArea.vue?vue&type=template&id=33b140a2&scoped=true"
import script from "./SelectArea.vue?vue&type=script&lang=js"
export * from "./SelectArea.vue?vue&type=script&lang=js"
import style0 from "./SelectArea.vue?vue&type=style&index=0&id=33b140a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b140a2",
  null
  
)

export default component.exports